import { getCartStorefront } from '@/api/cart';
import { bundleKey } from '@/helpers/bundleKey';
import { EVENT_MINICART_PRODUCT_ADD } from "@/store/events";

const CART_FIELDS = {
    id: false,
    attributes: false,
    checkoutUrl: false,
    cost: false,
    discountAllocations: false,
    discountCodes: false,
    updatedAt: false,
    lines: {
        id: false,
        attributes: true,
        cost: false,
        discountAllocations: false,
        quantity: true,
        sellingPlanAllocation: true,
        merchandise: {
            availableForSale: false,
            barcode: false,
            compareAtPrice: false,
            id: false,
            image: false,
            price: false,
            quantityAvailable: false,
            requiresShipping: false,
            selectedOptions: false,
            sku: false,
            title: false,
            weight: false,
            weightUnit: false,
            metafields: false,
            product: {
                id: false,
                availableForSale: false,
                createdAt: false,
                description: false,
                descriptionHtml: false,
                featuredImage: false,
                handle: false,
                isGiftCard: false,
                onlineStoreUrl: false,
                options: false,
                productType: false,
                publishedAt: false,
                requiresSellingPlan: false,
                sellingPlanGroups: false,
                seo: false,
                tags: true,
                title: false,
                totalInventory: false,
                updatedAt: false,
                vendor: false,
                images: false,
                media: false,
                variants: false,
                metafields: false,
            }
        }
    },
    note: false,
    totalQuantity: false,
    buyerIdentity: false,
};

async function getFormattedCart() {
    const cart = await getCartStorefront(null, CART_FIELDS, true);
    if (!cart) {
        return null;
    }

    const cartFormatted = {
        items: cart?.lines?.edges?.map(edge => {
            const node = edge.node;
            if (!node) {
                return null;
            }

            const properties = node.attributes || [];

            return {
                quantity: node.quantity,
                is_subscription: !!node.sellingPlanAllocation,
                selling_plan_name: node.sellingPlanAllocation?.sellingPlan?.name || null,
                pricing_strategy: properties.find((property) => property.key === '_pricing_strategy')?.value
            };
        }).filter(item => !!item)
    };

    return cartFormatted;
}

function initImageOverrides() {
    if (!window.ckImageOverrides || !window.ckImageOverrides.length) {
        return;
    }

    const $options = document.querySelectorAll('[data-single-option-selector]');

    if (!$options.length) {
        return;
    }

    $options.forEach((option) => {

        option.addEventListener('change', (event) => {
            const { value } = event.currentTarget;

            if (!value) {
                return;
            }

            const imageOverride = window.ckImageOverrides.filter((image_override) => image_override.condition === value);

            if (!imageOverride.length) {
                return;
            }

            imageOverride.forEach((image_override) => {
                const $targetImage = document.querySelector(`input[value="${image_override.target}"] + label .js-variant-image`);


                if (!$targetImage) {
                    return;
                }
                $targetImage.src = image_override.image;
            });
        });
    });
}

function initCKNewATC() {
    const $form = document.querySelector('#productForm');
    const productJSON = document.querySelector('#productObj');

    if (!$form || !productJSON) {
        return;
    }

    const atcButtons = document.querySelectorAll('[data-add-to-cart]');
    if (!atcButtons?.length) {
        return;
    }

    const productObj = JSON.parse(productJSON.textContent);

    atcButtons.forEach((btn) => {
        btn.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const options = {
                option1: $form.querySelector('input[data-index="option1"]:checked')
                    ? $form.querySelector('input[data-index="option1"]:checked')
                          .value
                    : null,
                option2: $form.querySelector('input[data-index="option2"]:checked')
                    ? $form.querySelector('input[data-index="option2"]:checked')
                          .value
                    : null,
                option3: $form.querySelector('input[data-index="option3"]:checked')
                    ? $form.querySelector('input[data-index="option3"]:checked')
                          .value
                    : null
            };

            const variantId = productObj.variants.filter((variant) => {
                return (
                    variant.option1 === options.option1 &&
                    variant.option2 === options.option2 &&
                    variant.option3 === options.option3
                );
            })[0].id;


            if (!variantId) {
                return;
            }

            atcButtons.forEach((atcButton) => {
                atcButton.classList.add('loading-blur');
            });

            let props = {};
            let CkUpsells = [];
            const checkForCkUpsell = $form.querySelector('[data-check-for-ck-upsells]');
            const limitNode = document.querySelector('[data-ck-upsells-limit]');
            const limit = limitNode ? parseInt(limitNode.dataset.ckUpsellsLimit || 0) : null;
            if (![
                checkForCkUpsell,
                window?.CkUpsells?.confirmed,
                (window?.CkUpsells?.variants || []).length === limit
            ].includes(false)) {
                const cart = await getFormattedCart();

                const subscription = (cart.items || []).find((item) => item?.is_subscription);

                const _frequency_interval = (subscription?.selling_plan_name || '').includes('60') ? '60' : '30';
                const _frequency_unit = 'day';
                const _pricing_strategy = subscription?.pricing_strategy || 'PRICING_STRATEGY_VOLUME_DISCOUNT';

                const _is_lash = '1';
                const _box_title = 'Monthly Box';
                const _box_handle = 'montly-box';
                const _box_image = window?.theme.image?.luxe_box_image || "//www.lashify.com/cdn/shop/files/luxe-box_541391be-1b84-4bc8-a536-7f4aabff24eb.jpg";

                const _added_from = window.location.href;

                const bundle_key = bundleKey();

                CkUpsells = window.CkUpsells.variants.map((variant) => {
                    const selling_plan = variant?.selling_plans?.find((selling_plan) => {
                        return ![
                            selling_plan?.selling_plan?.name?.includes(_frequency_interval),
                            selling_plan?.selling_plan?.name?.includes(`${ _frequency_unit }`)
                        ]?.includes(false);
                    })?.selling_plan?.id || null;

                    return {
                        quantity: 1,
                        id: variant.variant_id,
                        selling_plan,
                        properties: {
                            _subscription_upsell: true,
                            _frequency_interval,
                            _frequency_unit,
                            _pricing_strategy,
                            _is_lash,
                            _box_title,
                            _box_handle,
                            _box_image,
                            _selling_plan: +selling_plan,
                            _added_from,
                            bundle_product: "Control Kit",
                            _bundle_key: bundle_key,
                            _upsell: "true",
                            _purchase_option: "subscription",
                            _is_retail: true
                        }
                    };
                });

                props = {
                    bundle_product: "Control Kit",
                    _bundle_key: bundle_key,
                    _bundle_main_product: true
                };
            }

            const redirect_to_checkout = !!btn?.dataset?.productBuyNow || false;

            document.dispatchEvent(new CustomEvent(EVENT_MINICART_PRODUCT_ADD, {
                detail: {
                    items: [
                        {
                            quantity: 1,
                            id: variantId,
                            properties: props
                        },
                        ...(CkUpsells || []),
                    ],
                    callback() {
                        atcButtons?.forEach((atcButton) => {
                            atcButton?.classList?.remove('loading-blur');
                        });

                        if (redirect_to_checkout) {
                            const disabledSteps = document.querySelectorAll('.disabled-step');
                            if (disabledSteps?.length) {
                                disabledSteps.forEach((el) => {
                                    el.classList.remove('disabled-step');
                                    el.classList.add('slideUp');
                                });
                            }

                            setTimeout(() => {
                                window.location.href = '/checkout';
                            }, 4000);
                        }
                    }
                }
            }));
        });
    });
}

function checkIfSelection() {
  setTimeout(() => {
    const $form = document.querySelector('#productForm');
    const bottomMenu = document.querySelector('#shopify-section-mobile-sticky-menu');
    const inputs = Array.from($form.querySelectorAll('.selector-wrapper.active input[type="radio"]'));
    const isSelected = inputs.some(input => input.checked);
    const nextStepButton = $form.querySelector('.selector-wrapper.active .next-step');
    const fourthStepControlKit = document.querySelector('.control-kit__item-4');

    if (isSelected) {
        nextStepButton?.classList.remove('disabled-step');
        nextStepButton?.classList.add('slideUp');
        bottomMenu.style.display = 'none';
    } else {
       bottomMenu.style.display = 'block';
       nextStepButton?.classList.add('disabled-button');
    }

    if (fourthStepControlKit?.classList.contains('active')) {
      bottomMenu.style.display = 'block';
    }
   }, 100);
}


function initSkipCkUpsell() {
    if (!window?.CkUpsells) {
        return;
    }

    const btn = document.querySelector('[data-ck-upsells-handle-skip]');
    if (!btn) {
        return;
    }

    btn?.addEventListener('click', (event) => {
        event?.preventDefault();

        document.dispatchEvent(new Event('CkUpsells:skip'));

        const fourthStepControlKit = document.querySelector('.control-kit__item-4');
        if (!fourthStepControlKit) {
            return;
        }        


        fourthStepControlKit?.classList?.remove('active', 'success');
        fourthStepControlKit?.classList?.add('step-hidden', 'step-with-value', 'skipped');

        const fifthStepControlKit = document.querySelector('.control-kit__item-5');
        if (!fifthStepControlKit) {
            return;
        }

        fifthStepControlKit?.classList?.add('active');
        fifthStepControlKit?.classList?.remove('step-hidden', 'step-with-value');
    });
}

document.addEventListener('CkUpsells:success', () => {
    const fourthStepControlKit = document.querySelector('.control-kit__item-4');
    if (!fourthStepControlKit) {
        return;
    }

    fourthStepControlKit?.classList?.remove('active');
    fourthStepControlKit?.classList?.add('step-hidden', 'step-with-value', 'success');

    const fifthStepControlKit = document.querySelector('.control-kit__item-5');
    if (!fifthStepControlKit) {
        return;
    }

    fifthStepControlKit?.classList?.add('active');
    fifthStepControlKit?.classList?.remove('step-hidden', 'step-with-value');
});

document.addEventListener('CkUpsells:discarded', () => {
    const fourthStepControlKit = document.querySelector('.control-kit__item-4');
    if (!fourthStepControlKit) {
        return;
    }

    fourthStepControlKit?.classList?.remove('success');
});

function getNodeIndex(element) {
    return [].indexOf.call(element.parentNode.childNodes, element);
}

window.addEventListener('DOMContentLoaded', () => {

    initSkipCkUpsell();

    // next buttons
    const firstStepBtn = document.querySelector('.first-step');
    const secondStepBtn = document.querySelector('.second-step');
    const thirdStepBtn = document.querySelector('.third-step');
    const fourthStepBtn = document.querySelector('.fourth-step');

    /*
     * step items wrapper
     *  let mainStepControlKit = document.querySelector('.control-kit__item');
     */
    const firstStepControlKit = document.querySelector('.control-kit__item-1');
    const secondStepControlKit = document.querySelector('.control-kit__item-2');
    const thirdStepControlKit = document.querySelector('.control-kit__item-3');
    const fourthStepControlKit = document.querySelector('.control-kit__item-4');
    const fifthStepControlKit = document.querySelector('.control-kit__item-5');

    // change step
    const steps = [
        firstStepControlKit,
        secondStepControlKit,
        thirdStepControlKit,
        fourthStepControlKit,
        fifthStepControlKit
    ];

    if (fifthStepControlKit) {
        steps.push(fifthStepControlKit);
    }

    const buttonsStep = [firstStepBtn, secondStepBtn, thirdStepBtn];

    if (fourthStepBtn) {
        buttonsStep.push(fourthStepBtn);
    }

    for (let i = 0; i < buttonsStep.length; i++) {
        buttonsStep[i].addEventListener('click', (e) => {
            steps[i].classList.remove('active');
            steps[i].classList.add('step-hidden', 'step-with-value');
            steps[i + 1].classList.add('active');
            steps[i + 1].classList.remove('step-hidden', 'step-with-value');

            // handle close CkUpsells
            const closeCkUpsell = e.target.closest('[data-ck-upsell-close]');
            if (!closeCkUpsell) {
                return;
            }

            const limitNode = document.querySelector('[data-ck-upsells-limit]');
            const limit = limitNode ? parseInt(limitNode.dataset.ckUpsellsLimit || 0) : null;
            const badge = document.querySelector('[data-ck-upsells-badge]');

            if (!window?.CkUpsells?.confirmed || (window?.CkUpsells?.variants || []).length !== limit) {
                if (!badge) {
                    return;
                }

                badge.innerHTML = 'Skipped';
                steps[i + 1].classList.remove('success');
                return;
            }

            badge.innerHTML = 'Special Offer';
        });
    }

    

  function changeStep(event) {
        checkIfSelection();
        const elements = document.querySelectorAll('.control-kit__item');
        const stepParent = event.target.closest('.control-kit__item');
        elements.forEach((el) => {
            if (
                (getNodeIndex(el) <= getNodeIndex(stepParent) ||
                    el.classList.contains('active')) &&
                !el.classList.contains('control-kit__item--payment')
            ) {
                el.classList.add('step-with-value');
            }

            if (el.isEqualNode(stepParent)) {
                el.classList.remove('step-hidden', 'step-with-value');
                el.classList.add('active');
                const badge = el.querySelector('[data-ck-upsells-badge]');
                if (badge) {
                    badge.innerHTML = 'Special Offer';
                }

                const limitNode = document.querySelector('[data-ck-upsells-limit]');
                const limit = limitNode ? parseInt(limitNode.dataset.ckUpsellsLimit || 0) : null;

                if (!window?.CkUpsells?.confirmed || (window?.CkUpsells?.variants || []).length !== limit) {
                    el.classList.remove('success');
                }
            } else {
                el.classList.remove('active');
                el.classList.add('step-hidden');
            }
            
        });
    }

    const buttons = document.querySelectorAll('.change-step');
    const nextButtons = document.querySelectorAll('.next-step');
    
    buttons.forEach((button) => {
        button.addEventListener('click', changeStep);
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', checkIfSelection);
    });

    function removeDisabledStep() {
       const controlKitLabels = document.querySelectorAll('.control-kit__label');
        controlKitLabels.forEach((label) => {
            label.addEventListener('click', () => {
                checkIfSelection();
            });
        });
    }
    // Show mobile button if selection is made
    checkIfSelection();

    // Вызываем функцию, чтобы она начала работать
    removeDisabledStep();

    // submit form
    initCKNewATC();

    // image overrides
    initImageOverrides();
});
